<template>
    <li>
        <button class="nav-link"
                @click="show()">
            <fa class="fa-comments"></fa>
            Feedback
        </button>
        <common-dialog ref="dialog"
                       title="Send Us Feedback"
                       :buttons="buttons"
                       :disabled="loading"
                       @send="send"
                       @hidden="close"
                       @cancel="cancel">
            <template #body>
                <div v-if="sent" class="text-center">
                    <h4>Thank you for your feedback!</h4>
                    <fa class="fa-thumbs-up fa-4x"></fa>
                    <p>We love hearing from our customers and strive to always improve.  Your input makes a big difference!</p>
                </div>
                <div v-if="!sent">
                    <h6>Let us know about your experience or make a feature request.</h6>
                    <div class="my-2">
                        <select class="form-control"
                                v-model="model.type"
                                placeholder="Feedback Type"
                                :disabled="loading"
                                required>
                            <option v-for="option in list" :key="option.value"
                                    :value="option.value">
                                {{option.text}}
                            </option>
                        </select>
                    </div>
                    <div class="my-3">
                        <h6>What would you like to tell us?</h6>
                        <textarea class="form-control" style="height:6em"
                                  v-model="model.text"
                                  :disabled="loading"></textarea>
                    </div>
                    <div class="my-3">
                        <h6>How would you rate your overall experience with Fumbl.AI?</h6>
                        <div v-for="r in ratings" :key="r" class="form-check form-check-inline">
                            <label class="form-check-label" :for="'r' + r">{{rating(r)}}</label>
                            <input class="form-check-input"
                                   type="radio"
                                   name="rating"
                                   :id="'r' + r" :value="r"
                                   v-model="model.rating"
                                   :disabled="loading">
                        </div>
                    </div>
                    <div v-if="error" class="alert alert-warning">
                        <fa class="fa-lg fa-triangle-exclamation text-danger"></fa>
                        {{ error }}
                    </div>
                </div>
            </template>
        </common-dialog>
    </li>
</template>
<script>
    import axios from 'axios';
    import CommonDialog from './CommonDialog';

    const oops = 'Oops!  Something went wrong. Please try again later.';

    export default {
        components: {
            CommonDialog
        },
        computed: {
            buttons() {
                return this.sent ? [{
                    id: 'close',
                    html: 'Close',
                    classes: 'btn-default',
                    dismiss: true
                }] : [
                    {
                        id: 'cancel',
                        html: 'Cancel',
                        classes: 'btn-default',
                        dismiss: true,
                    },
                    {
                        id: 'send',
                        html: 'Send',
                        classes: 'btn-primary',
                    },
                ];
            },
            list() {
                return [
                    { text: 'I have a question or need help', value: 'question' },
                    { text: 'I want to report a problem', value: 'problem' },
                    { text: 'I want to request a feature or enhancement', value: 'feature' },
                    { text: 'I want to share my experience', value: 'experience' },
                    { text: 'Something else', value: 'other' },
                ];
            },
            ratings() {
                return [1, 2, 3, 4, 5];
            }
        },
        data: function () {
            return {
                error: '',
                loading: false,
                sent: false,
                model: {
                    rating: null,
                    text: '',
                    type: 'question'
                }
            };
        },
        methods: {
            rating(r) {
                return ['', 'Bad', 'Not Good', 'Okay', 'Good', 'Excellent'][r]
            },
            send() {
                const vm = this;
                vm.loading = true;
                vm.error = '';
                axios.post('/dashboard/feedback', vm.model)
                    .then(r => {
                        if (!r.data.success) {
                            vm.error = r.data.error || oops;
                            return;
                        }
                        vm.sent = true;
                    })
                    .catch(e => {
                        vm.error = e.message || oops;
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            },
            show() {
                this.$refs.dialog.show();
            },
            cancel() {
                this.error = null;
                this.loading = false;
                this.model.rating = null;
                this.model.text = '';
                this.model.type = 'question';
                this.sent = false;
            },
            close() {
                if (this.sent) {
                    this.cancel();
                }
            }
        }
    };
</script>